import { createContext } from 'react';
const screenDefaults = {
    availHeight: 0,
    availWidth: 0,
    colorDepth: 0,
    height: 0,
    orientation: {
        angle: 0,
        type: 'landscape-primary',
    },
    pixelDepth: 0,
    width: 0,
};
// latest chrome on desktop with most traffik as Dez 2021
const mdDefaultValues = {
    mobile: null,
    phone: null,
    tablet: null,
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/94.0.4606.81 Safari/537.36',
    os: null,
    iphone: false,
    isBot: false,
    chrome: 94.0460681,
    firefox: null,
    webkit: 537.36,
    ie: null,
    edge: 10,
    ios: null,
    android: null,
    wsParams: {
        isMobile: false,
        isTablet: false,
    },
    onload: true,
    isEmbeddedInBuyerApp: false,
};
export const BreakpointContext = createContext({
    breakpoint: 'desktop',
    screen: screenDefaults,
    angle: 0,
    md: mdDefaultValues,
    mdMatchesBrowser: true,
});
